import axios from "axios";

export function getUnprocessClaimNotification() {
  return new Promise((resolve, reject) => {
    axios
      .get(`/consumer/admin/api/v1/claims/notification-count`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
